// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "bootstrap/dist/js/bootstrap.bundle"
import "trix"
import "./controllers"
